<template>
  <div
    class="relative flex items-center justify-center bg-primary-950 text-sm text-white"
  >
    <p>
      🌈 <strong>Bienvenue sur Pollen !</strong> Votre prochaine formation vous
      attend !
    </p>

    <button class="absolute relative right-4" @click="$emit('close')">
      <app-icon icon="ph:x" :size="20" />
    </button>
  </div>
</template>

<script lang="ts" setup>
defineEmits(["close"]);
</script>
